// Modified login.js file with Login Method Selection
import { initSocket } from '../header/socketClient.js';
import Swal from "sweetalert2";
import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./login.css";
//import logo from "../../img/Zais_logo.png";
import "../sidebar/common.css";
import config from "../../config/config.json";
import { authenticationService } from "../../_services/authentication";
import { BehaviorSubject } from "rxjs";
import { PermissionMenuContext } from "../../contextApi/permissionBasedMenuContext";
import { apiCall } from "../../_services/apiCall";
import { Button, Col, Row, Spinner, Form } from "react-bootstrap";
import Eye from "../../img/eye-icon.png";
import EyeCross from "../../img/eye-icon-cross.png";
import logo from "../../img/netzherologo.png";

const baseURL = config.baseURL;

const SSO_PROVIDERS = [
  {
    id: "microsoft",
    label: "Microsoft",
    description: "Azure Entra / Work account",
    apiPath: "microsoft/login",
    ssoEnabledCheckPath: "microsoft/check",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 21 21" aria-hidden="true">
        <rect x="1"  y="1"  width="9" height="9" fill="#f25022" />
        <rect x="11" y="1"  width="9" height="9" fill="#7fba00" />
        <rect x="1"  y="11" width="9" height="9" fill="#00a4ef" />
        <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
      </svg>
    ),
  },
];


export default class signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLoginMethod: "email", // Default to email login
      user: {
        email: "",
        employeeId: "",
        password: "",
        firstname: "",
        lastname: "",
        isLoggedIn: false,
        userInfo: {
          name: "",
          emailId: "",
        },
      },
      captchaIsVerified: false,
      type: "password",
      submitted: false,
      captchaVerification: false,
      loading: false,
      showOtpVerification: false,
      otp: "",
      otpError: "",
      otpLoading: false,
      verificationData: null,
      showSsoModal: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleVerification = this.handleVerification.bind(this);
    this.showHide = this.showHide.bind(this);
    this.handleOtpChange = this.handleOtpChange.bind(this);
    this.verifyOtp = this.verifyOtp.bind(this);
    this.resendOtp = this.resendOtp.bind(this);
    this.handleLoginMethodChange = this.handleLoginMethodChange.bind(this);
  }

  static contextType = PermissionMenuContext;

  async handleSsoExchange() {
    this.setState({ loading: true });

    const { status, isSuccess, data } = await apiCall(
      `${config.AUTH_API_URL_COMPANY}sso/exchange`,
      {},
      {},
      "GET"
    );

    this.setState({ loading: false });

    if (status === 401) {
      Swal.fire({
        icon: "error",
        title: "Session Expired",
        text: "Your login session has expired. Please try again.",
      });
      return;
    }

    if (isSuccess) {
      this.setState({ verificationData: data });
      this.completeLogin(data);
    } else {
      Swal.fire({
        icon: "error",
        title: "Login failed",
        text: data?.message || "Invalid credentials",
        showConfirmButton: true,
        timer: 3000,
      });
    }
  }

  componentDidMount() {
    // ── Redirect already-logged-in users to the home page ──────────────────
    const token = localStorage.getItem("token");
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "null");

    if (token && currentUser) {
      const menu = JSON.parse(localStorage.getItem("menu") || "null");
      const hasDashboard = Array.isArray(menu) && menu.some((item) => item.url === "home");
      const targetUrl = hasDashboard ? "home" : (Array.isArray(menu) && menu[0]?.url) || "home";
      window.location.replace(`${window.location.origin}${window.location.pathname}#/${targetUrl}`);
      return;
    }
    // ───────────────────────────────────────────────────────────────────────

    // example: "#/login?ssoError=not_enabled"
    const { pathname, hash } = window.location;
    // Remove query params from hash
    const cleanHash = hash.split("?")[0];
    
    const queryString = hash.split("?")[1];
    
    if (!queryString) return;
    
    const params = new URLSearchParams(queryString);
    const ssoCallback = params.get("ssoCallback");
    const ssoError = params.get("ssoError");
    const ssoProvider = params.get("ssoProvider");
    
    
    console.log('pathname', pathname, 'hash', cleanHash);
    window.history.replaceState(null, "", pathname + cleanHash);
    if (ssoCallback === "true") {
      this.handleSsoExchange();
      return;
    }

    if (ssoError === "not_enabled") {
      Swal.fire({
        icon: "warning",
        title: "SSO Not Supported",
        text: "Single sign-on is not enabled for your organisation.",
      });
    } else if (ssoError === "unauthorized_user") {
      Swal.fire({
        icon: "error",
        title: "Access Denied",
        text: `Your ${ssoProvider ? `${ssoProvider} ` : ''}account is not authorized to access this application. Please contact your administrator.`,
      });
    } else if (ssoError === "unregistered_user") {
      Swal.fire({
        icon: "error",
        title: "Access Denied",
        text: `Your ${ssoProvider ? `${ssoProvider} ` : ''}account is not registered for access to this application. Please contact your administrator.`,
      });
    } else if (ssoError) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: `Failed to login via ${ssoProvider ? `${ssoProvider} ` : ''}Single Sign On`,
      });
    }
  }

  // Handle login method selection
  handleLoginMethodChange(method) {
    this.setState({
      selectedLoginMethod: method,
      user: {
        ...this.state.user,
        email: "", // Clear email field
        employeeId: "" // Clear employee ID field
      }
    });
  }

  handleSsoLogin(provider) {
    const traineeInviteToken = this.props.match.params?.token?.includes('&')
      ? this.props.match.params?.token?.split('&')[0]
      : this.props.match.params?.token;
    const loginUrl = `${config.AUTH_API_URL_COMPANY}${provider.apiPath}${traineeInviteToken ? `?traineeInviteToken=${traineeInviteToken}` : ''}`;
    window.location.href = loginUrl;
  }

  // Validate credentials based on selected login method
  validateCredentials() {
    const { selectedLoginMethod, user } = this.state;

    if (selectedLoginMethod === 'email') {
      if (!user.email || user.email.trim() === '') {
        return { isValid: false, message: 'Please enter your email address' };
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(user.email)) {
        return { isValid: false, message: 'Please enter a valid email address' };
      }
    } else {
      if (!user.employeeId || user.employeeId.trim() === '') {
        return { isValid: false, message: 'Please enter your Employee ID' };
      }

      // Validate employee ID format (customize based on your requirements)
      const employeeIdRegex = /^[A-Za-z0-9]{3,20}$/;
      if (!employeeIdRegex.test(user.employeeId)) {
        return { isValid: false, message: 'Please enter a valid Employee ID (3-20 alphanumeric characters)' };
      }
    }

    if (!user.password || user.password.trim() === '') {
      return { isValid: false, message: 'Please enter your password' };
    }

    return { isValid: true };
  }

  showHide(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      type: this.state.type === "password" ? "input" : "password",
    });
  }

  handleVerification() {
    this.setState({
      captchaIsVerified: true,
    });
  }

  logout = (response) => {
    let userInfo = {
      name: "",
      emailId: "",
    };
    this.setState({ userInfo, isLoggedIn: false });
  };

  handleChange(event) {
    const { name, value } = event.target;
    const { user } = this.state;

    this.setState({
      user: {
        ...user,
        [name]: value,
      },
    });
  }

  handleOtpChange(event) {
    this.setState({
      otp: event.target.value,
      otpError: ""
    });
  }

  async handleSubmit(event) {
    event.preventDefault();

    this.setState({ loading: true });

    let currentUserSubject = new BehaviorSubject(
      JSON.parse(localStorage.getItem("currentUser"))
    );

    localStorage.removeItem("currentUser");
    currentUserSubject.next(null);

    this.setState({ submitted: true });
    const { user, selectedLoginMethod } = this.state;

    // Validate credentials
    const validation = this.validateCredentials();
    if (!validation.isValid) {
      this.setState({ loading: false });
      Swal.fire({
        icon: "error",
        title: "Invalid Input",
        text: validation.message,
        showConfirmButton: true,
        timer: 3000,
      });
      return;
    }

    const result = this.props.match.params?.token?.includes('&')
      ? this.props.match.params?.token?.split('&')[0]
      : this.props.match.params?.token;

    // Prepare login payload based on selected login method
    const loginPayload = {
      password: user.password,
      token: result,
      userType: 'TRAINEE'
    };

    // Add appropriate field based on selected login method
    if (selectedLoginMethod === 'email') {
      loginPayload.email = user.email.trim();
    } else {
      loginPayload.employeeId = user.employeeId.trim();
    }

    const { isSuccess, data } = await apiCall(
      `${config.AUTH_API_URL_COMPANY}login`,
      {
        Portaltype: "COMPANY",
      },
      loginPayload,
      "POST",
      false,
      false
    );

    this.setState({ loading: false });

    if (isSuccess) {
      this.setState({ verificationData: data });

      // Check if 2FA is enabled
      if (data?.twoFaStatus) {
        this.sendOtpRequest(data);
      } else {
        this.completeLogin(data);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Login failed",
        text: data?.message || "Invalid credentials",
        showConfirmButton: true,
        timer: 3000,
      });
    }
  }

  async sendOtpRequest(data) {
    try {
      this.setState({ otpLoading: true });

      const { selectedLoginMethod, user } = this.state;

      // Prepare OTP payload
      const otpPayload = {
        userId: data?.user?.dataValues?.id
      };

      // Add appropriate identifier field
      if (selectedLoginMethod === 'email') {
        otpPayload.email = user.email.trim();
      } else {
        otpPayload.employeeId = user.employeeId.trim();
      }

      const { isSuccess, data: otpData } = await apiCall(
        `${config.AUTH_API_URL_COMPANY}sendOtp`,
        {},
        otpPayload,
        "POST"
      );

      this.setState({ otpLoading: false });

      if (isSuccess) {
        this.setState({ showOtpVerification: true });

        Swal.fire({
          icon: "success",
          title: "OTP Sent",
          text: `Please check your ${selectedLoginMethod === 'email' ? 'email' : 'registered contact'} for the OTP`,
          showConfirmButton: true,
          timer: 3000,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to send OTP",
          text: otpData?.message || "Please try again",
          showConfirmButton: true,
        });
      }
    } catch (error) {
      this.setState({ otpLoading: false });

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to send OTP. Please try again.",
        showConfirmButton: true,
      });
    }
  }

  async verifyOtp() {
    const { otp, verificationData, selectedLoginMethod, user } = this.state;

    if (!otp || otp.length !== 6) {
      this.setState({ otpError: "Please enter a valid 6-digit OTP" });
      return;
    }

    try {
      this.setState({ otpLoading: true });

      // Prepare verification payload
      const verifyPayload = {
        otp: otp,
        userId: verificationData?.user?.dataValues?.id
      };

      // Add appropriate identifier field
      if (selectedLoginMethod === 'email') {
        verifyPayload.email = user.email.trim();
      } else {
        verifyPayload.employeeId = user.employeeId.trim();
      }

      const { isSuccess, data } = await apiCall(
        `${config.AUTH_API_URL_COMPANY}verifyOtp`,
        {},
        verifyPayload,
        "POST"
      );

      this.setState({ otpLoading: false });

      if (isSuccess) {
        this.completeLogin(verificationData);
      } else {
        this.setState({ otpError: data?.message || "Invalid OTP" });
      }
    } catch (error) {
      this.setState({
        otpLoading: false,
        otpError: "Failed to verify OTP. Please try again."
      });
    }
  }

  async resendOtp() {
    const { verificationData } = this.state;
    if (verificationData) {
      this.sendOtpRequest(verificationData);
    }
  }

  // inside class methods
  async completeLogin(data) {
    let setResponse = {};
    setResponse.data = data;

    localStorage.setItem("tmpcurrentUser", JSON.stringify(setResponse));
    localStorage.setItem(
      "token",
      JSON.stringify(data?.token).replaceAll('"', "")
    );
    localStorage.setItem(
      "user_temp_id",
      JSON.stringify(data?.user.dataValues?.company_id)
    );
    localStorage.setItem("role", "company");

    localStorage.setItem(
      "currentUser",
      JSON.stringify({
        ...data?.user?.dataValues,
        is_head: data?.is_head,
        hasValidPlan: data.hasValidPlan,
      })
    );
    localStorage.setItem("menu", JSON.stringify(data?.menu));
    authenticationService.currentUserSubject.next(setResponse);
    try {
      const currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
      const userId = currentUser?.id;
      if (userId) {
        const s = initSocket(userId);
        s?.emit('addUser');
      }
    } catch (err) {
      console.warn('Socket init failed on login', err);
    }

    /* ── Fire internal attendance mark in background (non-blocking) ── */
    if (this.props.location?.pathname?.includes('trainee_invite_internal')) {
      const trainingToken = this.props.match.params?.token?.includes('&')
        ? this.props.match.params?.token?.split('&')[0]
        : this.props.match.params?.token;

      apiCall(
        `${config.POSTLOGIN_API_URL_COMPANY}markAsUnAteendant`,
        {},
        { token: trainingToken },
        "POST"
      );
    }

    /* ── Normal login redirect ── */
    Swal.fire({
      icon: "success",
      title: "Login Successful",
      text: data.message,
      showConfirmButton: true,
      timer: 1000,
    });

    const hasDashboard = data?.menu?.some((item) => item.url === "home");
    let rendarUrl = hasDashboard ? "home" : data?.menu[0]?.url;
    let pushToRoute = "/#/" + rendarUrl;
    let finalLink = baseURL + pushToRoute;

    setTimeout(() => {
      window.location.href = finalLink;
    }, 1000);
  }

  // Check if form is valid for submission
  isFormValid() {
    const { selectedLoginMethod, user } = this.state;

    if (selectedLoginMethod === 'email') {
      return user.email && user.password;
    } else {
      return user.employeeId && user.password;
    }
  }

  // Get current identifier value based on selected method
  getCurrentIdentifier() {
    const { selectedLoginMethod, user } = this.state;
    return selectedLoginMethod === 'email' ? user.email : user.employeeId;
  }

  renderSsoModal() {
    const { showSsoModal, ssoLoading } = this.state;
    if (!showSsoModal) return null;

    return (
      <>
        {/* Backdrop */}
        <div
          onClick={() => this.setState({ showSsoModal: false })}
          style={{
            position: "fixed", inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 1040,
            backdropFilter: "blur(2px)",
          }}
        />

        {/* Modal */}
        <div
          style={{
            position: "fixed",
            top: "50%", left: "50%",
            transform: "translate(-50%, -50%)",
            background: "#fff",
            borderRadius: "12px",
            padding: "28px 24px 20px",
            width: "min(92vw, 380px)",
            zIndex: 1050,
            boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
          }}
        >
          {/* Header */}
          <div className="d-flex align-items-center justify-content-between mb-1">
            <h5 style={{ margin: 0, fontWeight: 600, fontSize: "1.05rem" }}>
              Single Sign-On
            </h5>
            <button
              type="button"
              onClick={() => this.setState({ showSsoModal: false })}
              style={{
                background: "none", border: "none",
                cursor: "pointer", fontSize: "1.3rem",
                color: "#888", lineHeight: 1, padding: "2px 6px",
              }}
              aria-label="Close"
            >
              ×
            </button>
          </div>
          <p style={{ color: "#6c757d", fontSize: "0.82rem", marginBottom: "20px" }}>
            Choose your organisation's identity provider
          </p>

          {/* Provider list */}
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {SSO_PROVIDERS.map((provider) => (
              <button
                key={provider.id}
                type="button"
                onClick={() => this.handleSsoLogin(provider)}
                disabled={!!ssoLoading}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "14px",
                  padding: "11px 14px",
                  border: "1.5px solid #dee2e6",
                  borderRadius: "8px",
                  background: ssoLoading === provider.id ? "#f8f9fa" : "#fff",
                  cursor: ssoLoading ? "not-allowed" : "pointer",
                  textAlign: "left",
                  transition: "border-color 0.15s, box-shadow 0.15s",
                  outline: "none",
                }}
                onMouseEnter={e => {
                  if (!ssoLoading) e.currentTarget.style.borderColor = "#0d6efd";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = "#dee2e6";
                }}
              >
                {/* Icon box */}
                <span style={{
                  width: 36, height: 36, borderRadius: "6px",
                  background: "#f8f9fa",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0,
                }}>
                  {ssoLoading === provider.id
                    ? <Spinner animation="border" size="sm" />
                    : provider.icon
                  }
                </span>

                {/* Label + description */}
                <span style={{ flex: 1 }}>
                  <span style={{ display: "block", fontWeight: 600, fontSize: "0.9rem", color: "#212529" }}>
                    {ssoLoading === provider.id ? "Redirecting…" : provider.label}
                  </span>
                  {provider.description && (
                    <span style={{ display: "block", fontSize: "0.76rem", color: "#6c757d", marginTop: "1px" }}>
                      {provider.description}
                    </span>
                  )}
                </span>

                {/* Chevron */}
                {!ssoLoading && (
                  <span style={{ color: "#adb5bd", fontSize: "1rem" }}>›</span>
                )}
              </button>
            ))}
          </div>

          <p style={{
            textAlign: "center", marginTop: "18px", marginBottom: 0,
            fontSize: "0.75rem", color: "#adb5bd",
          }}>
            You'll be redirected to your provider to authenticate
          </p>
        </div>
      </>
    );
  }

  render() {
    const { token } = this.props.match.params;
    const {
      user,
      submitted,
      type,
      showOtpVerification,
      otp,
      otpError,
      otpLoading,
      selectedLoginMethod
    } = this.state;

    return (
      <div>
        <Row>
          <Col md={7} style={{ overflow: "hidden" }}>
            <video
              ref={(ref) => (this.videoRef = ref)}
              autoPlay
              loop
              muted
              className="video-background"
            >
              <source
                src="https://copyadatafromawstoazure.blob.core.windows.net/uploads/f6.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </Col>
          <Col md={5}>
            <section className="login">
              <div className="login_part">
                <div className="sing_log">
                  <div className="sing_one">
                    <img src={logo} alt="logo" className="w-50" />
                  </div>
                  <p className="text-center">
                    <b>Sign in to gain access</b>
                  </p>

                  {/* ── SSO entry point ───────────────────────── */}
                  <div className="form_sign mb-3" style={{marginTop: 40}}>
                    <Button
                      type="button"
                      variant="outline-secondary"
                      className="w-100 d-flex align-items-center justify-content-center gap-2"
                      style={{
                        fontWeight: 500,
                        borderRadius: "8px",
                        height: "46px",       // ← fixed height, same as your other buttons
                        fontSize: "0.9rem",
                      }}
                      onClick={() => this.setState({ showSsoModal: true })}
                    >
                      {/* Inline SVG with explicit, fixed dimensions — no inheritance issues */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        style={{ width: "16px", height: "16px", flexShrink: 0 }}  // ← both attribute + style to force size
                        aria-hidden="true"
                      >
                        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
                      </svg>
                      Continue with SSO
                    </Button>
                  </div>

                  {/* ── OR Divider ────────────────────────────── */}
                  <div className="d-flex align-items-center mb-3" style={{ gap: "10px" }}>
                    <hr style={{ flex: 1, margin: 0 }} />
                    <span className="text-muted" style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>OR</span>
                    <hr style={{ flex: 1, margin: 0 }} />
                  </div>

                  {!showOtpVerification ? (
                    // Login Form
                    <form name="form" onSubmit={this.handleSubmit}>
                      <div className="ster_form">
                        {/* Login Method Selection */}
                        <div className="form_sign mb-4">
                          <label className="st_name mb-3">
                            Choose Login Method
                          </label>
                          <div className="d-flex gap-3 mb-3">
                            <Button
                              variant={selectedLoginMethod === 'email' ? 'primary' : 'outline-primary'}
                              className="flex-fill"
                              onClick={() => this.handleLoginMethodChange('email')}
                              type="button"
                            >
                              📧 Email ID
                            </Button>
                            <Button
                              variant={selectedLoginMethod === 'employeeId' ? 'primary' : 'outline-primary'}
                              className="flex-fill"
                              onClick={() => this.handleLoginMethodChange('employeeId')}
                              type="button"
                            >
                              🆔 Employee ID
                            </Button>
                          </div>
                        </div>

                        {/* Conditional Input Field */}
                        <div className="form_sign">
                          <div className="form-group">
                            {selectedLoginMethod === 'email' ? (
                              <>
                                <label className="st_name" htmlFor="email">
                                  Email Address
                                </label>
                                <input
                                  className="form-control mb-3 p-3"
                                  type="email"
                                  name="email"
                                  id="email"
                                  placeholder="Enter your email address"
                                  value={user.email}
                                  onChange={this.handleChange}
                                  autoComplete="email"
                                />
                              </>
                            ) : (
                              <>
                                <label className="st_name" htmlFor="employeeId">
                                  Employee ID
                                </label>
                                <input
                                  className="form-control mb-3 p-3"
                                  type="text"
                                  name="employeeId"
                                  id="employeeId"
                                  placeholder="Enter your Employee ID"
                                  value={user.employeeId}
                                  onChange={this.handleChange}
                                  autoComplete="username"
                                />
                              </>
                            )}
                          </div>
                        </div>

                        {/* Password Field */}
                        <div className="form_sign password-eye">
                          <div className="img-eye">
                            <span onClick={this.showHide}>
                              {this.state.type === "input" ? (
                                <img src={EyeCross} alt="Hide password" />
                              ) : (
                                <img src={Eye} alt="Show password" />
                              )}
                            </span>
                          </div>
                          <div className="form-group">
                            <label className="st_name" htmlFor="password">
                              Password
                            </label>
                            <input
                              className="form-control mb-3 p-3"
                              type={type}
                              name="password"
                              id="password"
                              placeholder="Enter your password"
                              value={user.password}
                              onChange={this.handleChange}
                              autoComplete="current-password"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="text-end">
                        <span>
                          Forgot Password?
                          <NavLink to="/ResetPass"> Reset </NavLink>
                        </span>
                      </div>

                      <Row className="my-4">
                        <Col>
                          {this.state.loading ? (
                            <Button variant="info" className="w-100 p-3" disabled>
                              <Spinner animation="border" size="sm" /> Logging in...
                            </Button>
                          ) : this.isFormValid() ? (
                            <Button
                              type="submit"
                              className="w-100 p-3"
                              variant="info"
                            >
                              <b>Login with {selectedLoginMethod === 'email' ? 'Email' : 'Employee ID'}</b>
                            </Button>
                          ) : (
                            <Button
                              variant="secondary"
                              className="w-100 p-3"
                              disabled
                            >
                              <b>Enter Credentials to Login</b>
                            </Button>
                          )}
                        </Col>
                        {token && (
                          <div className='text-center mt-2'>
                            <h5>
                              Don't have an account?
                              <NavLink
                                to={`/trainee_registration/${token}`}
                                style={{ color: "#3F88A5", cursor: 'pointer' }}
                              >
                                Sign Up
                              </NavLink>
                            </h5>
                          </div>
                        )}
                        {this.props.location?.pathname.includes('trainee_login') && (
                          <div className='text-center mt-2'>
                            <h5>
                              Don't have an account?
                              <NavLink
                                to={`/trainee_registration`}
                                style={{ color: "#3F88A5", cursor: 'pointer' }}
                              >
                                Sign Up
                              </NavLink>
                            </h5>
                          </div>
                        )}
                      </Row>
                    </form>
                  ) : (
                    // OTP Verification Form
                    <div>
                      <div className="text-center mb-4">
                        <h4>OTP Verification</h4>
                        <p>
                          We've sent a verification code to your{" "}
                          {selectedLoginMethod === 'email' ? 'email address' : 'registered contact'}
                        </p>
                        <small className="text-muted">
                          <strong>Login Method:</strong> {selectedLoginMethod === 'email' ? 'Email' : 'Employee ID'}
                          <br />
                          <strong>Identifier:</strong> {this.getCurrentIdentifier()}
                        </small>
                      </div>

                      <div className="form-group mb-4">
                        <label className="st_name" htmlFor="otp">
                          Enter 6-digit OTP
                        </label>
                        <input
                          className="form-control mb-2 p-3 text-center"
                          type="text"
                          name="otp"
                          id="otp"
                          placeholder="Enter OTP"
                          value={otp}
                          onChange={this.handleOtpChange}
                          maxLength="6"
                          pattern="[0-9]{6}"
                        />
                        {otpError && (
                          <div className="text-danger small">{otpError}</div>
                        )}
                      </div>

                      <Row className="mb-3">
                        <Col>
                          {otpLoading ? (
                            <Button variant="info" className="w-100 p-3" disabled>
                              <Spinner animation="border" size="sm" /> Verifying...
                            </Button>
                          ) : (
                            <Button
                              type="button"
                              className="w-100 p-3"
                              variant="info"
                              onClick={this.verifyOtp}
                              disabled={!otp || otp.length !== 6}
                            >
                              <b>Verify OTP</b>
                            </Button>
                          )}
                        </Col>
                      </Row>

                      <div className="text-center">
                        <p className="mb-2">
                          Didn't receive code?{" "}
                          <span
                            style={{ color: "#3F88A5", cursor: "pointer", textDecoration: "underline" }}
                            onClick={this.resendOtp}
                          >
                            Resend OTP
                          </span>
                        </p>
                        <p>
                          <span
                            style={{ color: "#3F88A5", cursor: "pointer", textDecoration: "underline" }}
                            onClick={() => this.setState({
                              showOtpVerification: false,
                              otp: "",
                              otpError: ""
                            })}
                          >
                            ← Back to Login
                          </span>
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </Col>
        </Row>
        {this.renderSsoModal()}
      </div>
    );
  }
}
